import flBusiness from '@framelink/flbusiness'
import qs from 'qs'

export const getPublicForm = (url) => {
	const token = qs.parse(url, { ignoreQueryPrefix: true })
	return flBusiness.PublicApi.Form.load(token.f)
}

export const adminInit = () => flBusiness.adminInit()

export const initApi = () => flBusiness.Version.api()

export const getVersion = () => flBusiness.Version.get()

export const getField = (id) => flBusiness.Field.get(id)

export const compressImage = (string) => flBusiness.Utils.compressImage(string)

export const getFileUrl = (string) => flBusiness.Utils.getFileUrl(string)

export const getLinkedOptions = (fieldId, doc) => flBusiness.Field.Linked.getOptions(fieldId, doc)

export const filterList = (array, pattern, props) => flBusiness.Utils.filter(array, pattern, props)

export const submitForm = (formId, model) => flBusiness.PublicApi.Form.submit(formId, model)

export const entityError = flBusiness.Enum.ErrorCode.NoEntity

export const formError = flBusiness.Enum.ErrorCode.NoPublicForm

